import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Col, Dropdown, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
  tenantDeviceInfos,
  allTenantDevices,
} from '../Dashboard/DashboardSlice';
import { timestampToDate } from '../../common/handleTimestamp';
import { getDataCustomers } from '../Customers/CustomersSlice';
import Breadcrumbs from '../../designs/Breadcrumbs/Breadcrumbs';
//Table ant design
import { Table } from 'ant-table-extensions';
import { SearchOutlined } from '@ant-design/icons';
import * as Icon from 'react-feather';
import ExportExcelButton from '../../components/ExportExcel/ExportExcelButton';

const Report = () => {
  const { t } = useTranslation();
  const table = document.querySelector('table');
  const [typeReport, setTypeReport] = useState('1');
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');

  const dataCustomers = useSelector((state) => state.customers.customers);
  const customerStatus = useSelector((state) => state.customers.status);
  const reportStatus = useSelector((state) => state.dashboard.status);

  const [isMaximize, setMaximize] = useState(false);
  const [changeIcon, setChangeIcon] = useState(true);
  // table ant
  const [loading, setLoading] = useState(false);
  const [curPage, setCurPage] = useState(1);
  const [pagination, setPagination] = useState({
    current: curPage,
    pageSize: 10,
    total: 10,
  });

  useEffect(() => {
    dispatch(tenantDeviceInfos({ token }));
  }, [dispatch, token]);

  useEffect(() => {
    dispatch(getDataCustomers({ token }));
  }, [dispatch, token]);

  useEffect(() => {
    if (customerStatus === 'loading' || reportStatus === 'loading') {
      setLoading(true);
    } else {
      if (typeReport === 1)
        setPagination({ ...pagination, total: tenantDevices?.totalElements });
      else if (typeReport === 2)
        setPagination({ ...pagination, total: dataCustomers?.totalElements });
      setLoading(false);
    }
  }, [customerStatus, reportStatus]);

  const tenantDevices = useSelector(allTenantDevices);

  const rowFilterStation = tenantDevices.data?.map((item, idx) => ({
    key: idx,
    id: item.id.id,
    device: item.name,
    type: item.type,
    label: item.additionalInfo.description,
    dateCreated: timestampToDate(item.createdTime),
  }));

  const columnsFilterStation = [
    {
      title: 'ID',
      dataIndex: 'id',
      sort: 'disabled',
      key: 'id',
      width: 400,
      render: (id) => <Link to={`/attribute/${id}`}>{id}</Link>,
    },
    {
      title: t('device').toUpperCase(),
      dataIndex: 'device',
      width: 200,
      key: 'device',
    },
    {
      title: t('type').toUpperCase(),
      dataIndex: 'type',
      key: 'type',
      width: 150,
    },
    {
      title: t('label').toUpperCase(),
      dataIndex: 'label',
      key: 'label',
      width: 300,
    },
    {
      title: t('date-created').toUpperCase(),
      dataIndex: 'dateCreated',
      key: 'dateCreated',
      width: 300,
    },
  ];
  const rowDataCustomer = dataCustomers.data?.map((item, idx) => ({
    key: idx,
    id: item.id.id,
    customer: item.name,
    phone: item.phone,
    email: item.email,
  }));

  const columnsDataCustomers = [
    {
      title: 'ID',
      dataIndex: 'id',
      sort: 'disabled',
      width: 200,
      key: 'id',
      render: (id) => <Link to={`/device/${id}`}>{id}</Link>,
    },
    {
      title: t('customer').toUpperCase(),
      dataIndex: 'customer',
      width: 300,
      key: 'customer',
    },
    {
      title: t('phone').toUpperCase(),
      dataIndex: 'phone',
      key: 'phone',
      width: 300,
    },
    {
      title: 'email'.toUpperCase(),
      dataIndex: 'email',
      key: 'email',
      width: 300,
    },
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    if (curPage !== pagination.current) {
      const pageSize = pagination.pageSize;
      const page = pagination.current - 1;
      if (typeReport === 1)
        dispatch(getDataCustomers({ token, pageSize, page }));
      else if (typeReport === 2) dispatch(tenantDeviceInfos({ token }));
      setCurPage(pagination.current);
    }
    setPagination(pagination);
  };

  // Extend card
  const extendCard = () => {
    var card = document.getElementById('card');

    setMaximize(!isMaximize);
    if (card.classList.contains('card-extend'))
      card.classList.remove('card-extend');
    else card.classList.add('card-extend');
  };

  // Reload card
  const reload = () => {
    var card = document.getElementById('card');
    card.classList.add('card-load');
    var div = document.createElement('div');
    var i = document.createElement('i');
    div.classList.add('card-loader');
    div.id = 'loader';
    i.classList.add('pct-loader1');
    i.classList.add('anim-rotate');
    div.appendChild(i);
    card.appendChild(div);
    setTimeout(() => {
      card.removeChild(div);
      card.classList.remove('card-load');
    }, 3000);
  };

  return (
    <div className="pcoded-main-container">
      <div className="pcoded-wrapper">
        <div className="pcoded-content">
          <div className="pcoded-inner-content">
            <div className="main-body">
              <div className="page-wrapper">
                <Breadcrumbs floor={[{ name: t('report') }]} />
                <div className="page-header">
                  <div className="page-block"></div>
                </div>
                <Row>
                  <Col sm={12}>
                    <Card>
                      <Card.Header>
                        <h5>{t('type-report')}</h5>
                      </Card.Header>
                      <Card.Body>
                        <Form.Select
                          aria-label="Default select example"
                          id="selectTypeReport"
                          defaultValue="1"
                          onChange={(e) => setTypeReport(e.target.value)}
                        >
                          <option value="1">{t('filter-station')}</option>
                          <option value="2">{t('customer')}</option>
                        </Form.Select>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col sm={12}>
                    <Card id="card">
                      <Card.Header>
                        {typeReport === '1' ? (
                          <h5>{t('filter-station-report')}</h5>
                        ) : (
                          <h5>{t('customer-report')}</h5>
                        )}
                        <div className="card-header-right">
                          <Dropdown
                            id="dropdown"
                            onToggle={() => setChangeIcon(!changeIcon)}
                          >
                            <Dropdown.Toggle variant="none" id="dropdown-basic">
                              {changeIcon ? (
                                <i className="feather icon-more-horizontal"></i>
                              ) : (
                                <i className="feather icon-chevron-down"></i>
                              )}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {!isMaximize ? (
                                <Dropdown.Item
                                  onClick={() => {
                                    extendCard();
                                  }}
                                >
                                  <Icon.Maximize size={16} /> {t('extend')}
                                </Dropdown.Item>
                              ) : (
                                <Dropdown.Item
                                  onClick={() => {
                                    extendCard();
                                  }}
                                >
                                  <Icon.Minimize size={16} /> {t('restore')}
                                </Dropdown.Item>
                              )}
                              <Dropdown.Item
                                onClick={() => {
                                  reload();
                                }}
                              >
                                <Icon.RefreshCw size={16} /> {t('reload')}
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </Card.Header>
                      <Card.Body id="cardBody">
                        {typeReport === '1' ? (
                          <>
                            <ExportExcelButton
                              table={table}
                              name="FilterStationReport"
                              sheet="FilterStation"
                            />
                            <Table
                              columns={columnsFilterStation}
                              dataSource={rowFilterStation}
                              pagination={pagination}
                              loading={loading}
                              onChange={handleTableChange}
                              scroll={{ x: true }}
                              searchableProps={{
                                inputProps: {
                                  placeholder: t('search-table'),
                                  prefix: <SearchOutlined />,
                                  style: {
                                    maxWidth: '350px',
                                    padding: '6px',
                                    borderRadius: '5px',
                                  },
                                },
                                fuzzySearch: true,
                              }}
                            />
                          </>
                        ) : (
                          <>
                            <ExportExcelButton
                              table={table}
                              name="CustomerReport"
                              sheet="Customer"
                            />
                            <Table
                              columns={columnsDataCustomers}
                              dataSource={rowDataCustomer}
                              pagination={pagination}
                              loading={loading}
                              onChange={handleTableChange}
                              scroll={{ x: true }}
                              searchableProps={{
                                inputProps: {
                                  placeholder: t('search-table'),
                                  prefix: <SearchOutlined />,
                                  style: {
                                    maxWidth: '350px',
                                    padding: '6px',
                                    borderRadius: '5px',
                                  },
                                },
                                fuzzySearch: true,
                              }}
                            />
                          </>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Report;
